import { render, staticRenderFns } from "./pbjf.vue?vue&type=template&id=c78ace8e&scoped=true&"
import script from "./pbjf.vue?vue&type=script&lang=js&"
export * from "./pbjf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78ace8e",
  null
  
)

export default component.exports